import { handleActions } from "redux-actions";
import * as actions from "@/store/action/order/index";

const emailReducer = handleActions(
  {
    [actions.resetFetchState]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
    [actions.orderTimeLineSuccess]: (state, action) => {
      return {
        ...state,
        // orderTimeLine: action.payload.data,
        orderTimeLine: action.payload.data,
        orderTimeLineSuccess: true,
        isOrderTimeLine: action.payload.dynamicPermission
      };
    },
    [actions.getTravelInfoSuccess]: (state, action) => {
      return {
        ...state,
        getTravelInfo: action.payload,
        getTravelInfoSuccess: true,
      };
    },
    [actions.getCompensateReasonListSuccess]: (state, action) => {
      return {
        ...state,
        getCompensateReasonList: action.payload.compensateReason,
        getCompensateReasonListSuccess: true,
      };
    },

    [actions.closeOrderSuccess]: (state, action) => {
      return {
        ...state,
        closeOrder: action.payload,
        closeOrderSuccess: true,
      };
    },
    [actions.getOpenTicketByOrderSuccess]: (state, action) => {
      return {
        ...state,
        getOpenTicketByOrder: action.payload.tickets || [],
        getOpenTicketByOrderSuccess: true,
      };
    },
    [actions.getImHistorySuccess]: (state, action) => {
      return {
        ...state,
        getImHistory: action.payload.info || [],
        getImHistorySuccess: true,
      };
    },
    [actions.getCallHistorySuccess]: (state, action) => {
      return {
        ...state,
        getCallHistory: action.payload.info || [],
        getCallHistorySuccess: true,
      };
    },
    [actions.getBusStationInfoSuccess]: (state, action) => {
      return {
        ...state,
        getBusStationInfo: action.payload.data || [],
        getBusStationInfoSuccess: true,
      };
    },
    [actions.queryPrivacyRightsSuccess]: (state, action) => {
      return {
        ...state,
        queryPrivacyRights: action.payload.data,
        queryPrivacyRightsSuccess: true,
      };
    },
    [actions.showToolBoxSuccess]: (state, action) => {
      return {
        ...state,
        showToolBox: action.payload.data,
        showToolBoxSuccess: true,
      };
    },
  },
  actions.initStateData
);

export default emailReducer;
